import SearchIcon from "@mui/icons-material/Search";
import { Box, Grid, styled, Tab, TextField } from "@mui/material";
import { api, types } from "api";
import { ColorTabs } from "components/ColorTabs";
// import { useBreadcrumbs } from "helpers/useBreadcrumbs";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { routes } from "routes";
import { useAuthStatus } from "../../helpers/useAuthStatus";
import { GET_RESULT_FAIL } from "../../messages";
import { GroupTable } from "./Component/GroupTable";

const PREFIX = "GroupTablePage";

const classes = {
	root: `${PREFIX}-root`,
	tabs: `${PREFIX}-tabs`,
	tabsBarBox: `${PREFIX}-tabsBarBox`,
	button: `${PREFIX}-button`,
	buttonList: `${PREFIX}-buttonList`,

	appBar: `${PREFIX}-appBar`,
	indicator: `${PREFIX}-indicator`,
	table: `${PREFIX}-table`,
};

const Root = styled("div")(({ theme }) => ({
	[`&.${classes.root}`]: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
	[`& .${classes.tabs}`]: {
		color: "white",
	},
	[`& .${classes.tabsBarBox}`]: {
		backgroundColor: theme.palette.primary.main,
	},
	[`& .${classes.button}`]: {
		minWidth: theme.spacing(21),
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	[`& .${classes.buttonList}`]: {
		display: "flex",
	},

	[`& .${classes.appBar}`]: {
		backgroundColor: theme.palette.primary.main,
	},

	[`& .${classes.table}`]: {
		marginTop: theme.spacing(4),
	},
}));

interface stateType {
	groups: types.Group[];
}

export const GroupTablePage = (): JSX.Element => {
	const [groupName, setGroupName] = useState("");

	const { role } = useAuthStatus();
	// const { updateLastBreadcrumbs } = useBreadcrumbs();
	const [, setErr] = useState("");
	const [groups, setGroups] = useState<types.Group[]>([]);
	const [allGroups, setAllGroups] = useState<types.Group[]>([]);
	const location = useLocation<stateType>();
	const [isloading, setIsloading] = useState(true);

	const fetchGroups = useCallback(() => {
		api
			.getGroups()
			.then((res) => {
				if (res.status !== 200) {
					throw new Error();
				}
				setErr("");
				if (res.data === null || res.data.length === 0) {
					setGroups([]);
					return;
				}

				setGroups(res.data);
				setAllGroups(res.data);
				setIsloading(false);
			})
			.catch(() => {
				setErr(GET_RESULT_FAIL);
			});
	}, []);

	useEffect(() => {
		if (location.state === undefined) {
			if (role === "admin" || role === "teacher" || role === "admin-teacher") {
				fetchGroups();
			}
		} else {
			setGroups(location.state.groups);
			setAllGroups(location.state.groups);
		}
	}, [role, fetchGroups, location]);

	return (
		<Root className={classes.root}>
			<Box
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				className={classes.tabsBarBox}
			>
				<ColorTabs
					value={routes._.metrics._.Groups.path}
					variant="scrollable"
					scrollButtons
				>
					<Tab
						label="GROUP LIST"
						value={routes._.metrics._.Groups.path}
						sx={{ color: "white" }}
						classes={{
							root: classes.tabs,
						}}
						component={Link}
						to={routes._.metrics._.Groups.path}
					/>
					<Tab
						label="STUDENT LIST"
						value={routes._.metrics._.Students.path}
						sx={{ color: "white" }}
						classes={{
							root: classes.tabs,
						}}
						component={Link}
						to={routes._.metrics._.Students.path}
					/>
					<Tab
						label="School Metrics"
						value={routes._.metrics._.School.path}
						sx={{ color: "white" }}
						classes={{
							root: classes.tabs,
						}}
						component={Link}
						to={routes._.metrics._.School.path}
					/>
					{role === "admin" && (
						<Tab
							label="Registered Users"
							value={routes._.metrics._.RegisteredUsers.path}
							sx={{ color: "white" }}
							classes={{
								root: classes.tabs,
							}}
							component={Link}
							to={routes._.metrics._.RegisteredUsers.path}
						/>
					)}
				</ColorTabs>
			</Box>

			<GroupTable groups={groups} isloading={isloading}>
				<Grid item xs={4}>
					{/* <TextField
						id="group-name"
						label="Group Name"
						variant="outlined"
						value={groupName}
						onChange={(e) => {
							setGroupName(e.target.value);
						}}
						fullWidth
						InputProps={{
							endAdornment: <SearchIcon />,
						}}
					/> */}
					<TextField
						id="group-name"
						label="Group Name"
						variant="outlined"
						value={groupName}
						onChange={(e) => {
							const searchName = e.target.value;
							if (searchName.length < groupName.length) {
								// monitor backspace
								setGroups(allGroups);
							} else {
								let searchGroups: Array<types.Group> = [];
								const regex = /^ *$/;
								// a name is null or empty string or all whitespace
								if (regex.exec(searchName) !== null) {
									setGroups(allGroups);
								} else {
									groups.forEach((group) => {
										if (
											group.name
												.toLowerCase()
												.includes(searchName.trim().toLowerCase())
										) {
											searchGroups = [...searchGroups, group];
										}
									});
									setGroups(searchGroups);
								}
							}
							setGroupName(searchName);
						}}
						fullWidth
						InputProps={{
							endAdornment: <SearchIcon />,
						}}
					/>
				</Grid>
			</GroupTable>
		</Root>
	);
};
